import "./styles.scss";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { useApp } from "context/app";

import api from "libs/api";

import ModalNew from "components/ModalNew";
import UserPicker from "components/UserPicker";
import Select from "components/form/Select";
import Input from "components/form/Input";
import Button from "components/Button";

const mainClass = "send-notification";

const initialData = {
  to: [],
  title: "",
  website: null,
  message: "",
};

const SendNotification = ({ rmButton }) => {
  const { t } = useTranslation();

  const {
    websites,
    webmasters,
    admins,
    send_notification_open,
    setSendNotificationOpen,
  } = useApp();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(initialData);

  const formatted_websites = websites?.map(({ _id, website }) => ({
    label: website,
    value: _id,
  }));

  const formatted_webmasters = webmasters?.map(
    ({ _id, first_name, last_name, photo }) => ({
      id: _id,
      name: `${first_name} ${last_name}`,
      image: photo?.location,
    }),
  );

  const formatted_admins = admins?.map(
    ({ _id, first_name, last_name, photo }) => ({
      id: _id,
      name: `${first_name} ${last_name}`,
      image: photo?.location,
    }),
  );

  const users_options = [
    ...(formatted_admins || []),
    ...(formatted_webmasters || []),
  ].sort((a, b) => a.name.localeCompare(b.name));

  const handleClose = () => {
    setSendNotificationOpen(false);
    setData(initialData);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);

      await api.post(`/admin/dashboard/send-notification`, {
        message: `${data.title} - ${data.message}`,
        send_to: data.to.map((user) => user.id),
        website: data.website?.value,
      });

      toast.success(t("Notification has been sent."));
      setSendNotificationOpen(false);
      setData(initialData);
    } catch (err) {
      console.error(err);
    }

    setLoading(false);
  };

  return (
    <>
      {!rmButton && (
        <Button onClick={() => setSendNotificationOpen(true)}>
          {t("Send notification")}
        </Button>
      )}

      <ModalNew
        title={t("Send notification")}
        variant="wide"
        labelSubmit="Send"
        loading={loading}
        isOpen={send_notification_open}
        isBackdropDisabled
        isSubmitDisabled={
          !(data.to.length > 0) ||
          !(data.title.length > 0) ||
          data.website === null ||
          !(data.message.length > 0)
        }
        onClose={handleClose}
        onSubmit={handleSubmit}
      >
        <div className={mainClass}>
          <div className={`${mainClass}__field ${mainClass}__field--full`}>
            <p className={`${mainClass}__label`}>{t("To")}</p>
            <UserPicker
              options={users_options}
              onChange={(selected) =>
                setData((prevData) => ({ ...prevData, to: selected }))
              }
            />
          </div>
          <div className={`${mainClass}__field`}>
            <p className={`${mainClass}__label`}>{t("Title")}</p>
            <Input
              placeholder={t("Enter")}
              value={data.title}
              onChange={(e) =>
                setData((prevData) => ({ ...prevData, title: e.target.value }))
              }
            />
          </div>
          <div className={`${mainClass}__field`}>
            <p className={`${mainClass}__label`}>{t("Website")}</p>
            <Select
              placeholder={t("Select")}
              options={formatted_websites}
              value={data.website?.value}
              searcher
              onChange={(option) =>
                setData((prevData) => ({
                  ...prevData,
                  website: option,
                }))
              }
            />
          </div>
          <div className={`${mainClass}__field ${mainClass}__field--full`}>
            <p className={`${mainClass}__label`}>{t("Message")}</p>
            <Input
              type="textarea"
              placeholder={t("Your message")}
              value={data.message}
              onChange={(e) =>
                setData((prevData) => ({
                  ...prevData,
                  message: e.target.value,
                }))
              }
            />
          </div>
        </div>
      </ModalNew>
    </>
  );
};

export default SendNotification;
